import CascaderSelect from '@alifd/next/lib/cascader-select';
export default CascaderSelect;